import jsonParse from "web/utils/data/parser/string/jsonParse";
import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import type { IPaymentSettingsItem } from "web/types/Payment";

export type PaymentSettingsInput =
  | IPaymentSettingsItem[]
  | string
  | null
  | undefined;

const parsePaymentSettings = (
  paymentSettings?: PaymentSettingsInput
): IPaymentSettingsItem[] => {
  if (typeof paymentSettings === "string") {
    const parsed = jsonParse<IPaymentSettingsItem[]>(paymentSettings, true);
    return isArrayHasItems(parsed) ? parsed : [];
  }

  return isArrayHasItems(paymentSettings) ? paymentSettings : [];
};

export default parsePaymentSettings;
